/**
 * PermissionLoadingState Component
 * Displays loading state while checking permissions
 */

import React from 'react'
import { Box } from '@mui/material'
import Spinner from '../../../../interaxDesignSystemComponents/Spinner'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

export const PermissionLoadingState: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}
    >
      <Spinner size="large" color="sun" text={t('gamer.permissionScreen.checking')} />
    </Box>
  )
}
